import dayjs from "dayjs";
import {EntityBase} from "../../../shared/entity/EntityBase";

// 세그먼트 그룹(event_segment) + 그룹에 속한 이벤트별 조건(event_segment_group)
const EVENT_SEGMENT_FIELDS = {
    seq: {type: (v) => parseInt(v) || 0, defaultValue: 0},
    memo: {defaultValue: ''},
    lastPayment: {type: Number, defaultValue: 0},
    averagePayment: {type: Number, defaultValue: 0},
    paymentCount: {type: Number, defaultValue: 0},
    baseDate: {type: (v) => dayjs(v).format('YYYY-MM-DD'), defaultValue: dayjs().format('YYYY-MM-DD')},
    cumulativeLoginCount: {type: Number, defaultValue: 0},
    cumulativePayment: {type: Number, defaultValue: 0},
    isCumPaymentOver: {type: Number, defaultValue: 1},
    items: {type: Array, defaultValue: []},
};

export const newSegmentItem = () => ({typeIndex: 0, minAvrPayment: 0, maxAvrPayment: 0, minLevel: 0, maxLevel: 0});

export class EventSegmentEntity extends EntityBase {
    constructor(data = {}) {
        super(data, EVENT_SEGMENT_FIELDS);
        const items = this.items.map(item => ({...item, minAvrPayment: Number(item.minAvrPayment), maxAvrPayment: Number(item.maxAvrPayment)}));
        const typeIndexes = items.map(item => item.typeIndex);
        this.errors = [
            {condition: () => items.length === 0, message: '이벤트를 1개 이상 추가하세요.'},
            {condition: () => typeIndexes.some(typeIndex => !typeIndex), message: '이벤트를 선택하세요.'},
            {condition: () => new Set(typeIndexes).size !== typeIndexes.length, message: '같은 이벤트를 중복으로 넣을 수 없습니다.'},
            {condition: () => items.some(item => item.maxAvrPayment > 0) && !(this.averagePayment > 0), message: '평균 결제 금액 조건 사용 시 평균 결제일을 입력해야 합니다.'},
            {condition: () => items.some(item => item.maxAvrPayment > 0 && item.minAvrPayment >= item.maxAvrPayment), message: '평균 결제 금액: 이상값은 미만값보다 작아야 합니다.'},
            {condition: () => items.some(item => item.maxLevel > 0 && item.minLevel >= item.maxLevel), message: '레벨: 이상값은 미만값보다 작아야 합니다.'},
        ];
    }

    getIdentityKey() {
        return 'seq';
    }
}
